import { getUnifiedModule } from '@/utilities/logger/amplitude/initialise';
import { launchedFrom } from './helpers';
import { getAmplitudeKey } from './constants';

/**
 * Fires an Amplitude event via the unified SDK. Resolves once the SDK is ready,
 * so events emitted before init complete are queued and flushed later.
 */
export const logTrackingEvent = (payload: Record<string, unknown>): void => {
  const enriched: Record<string, unknown> = {
    ...payload,
    [getAmplitudeKey('LAUNCHED_FROM')]: launchedFrom(),
  };
  const { Event, ...rest } = enriched as { Event: string } & Record<
    string,
    unknown
  >;

  getUnifiedModule()
    .then((mod) => {
      mod.track(Event, rest);
    })
    .catch(() => {
      /* swallow — analytics must never break the app */
    });
};
